import { render, staticRenderFns } from "./filter.vue?vue&type=template&id=bd165ed4&scoped=true"
import script from "./filter.vue?vue&type=script&lang=js"
export * from "./filter.vue?vue&type=script&lang=js"
import style0 from "./filter.vue?vue&type=style&index=0&id=bd165ed4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd165ed4",
  null
  
)

export default component.exports